import React, { useEffect, useState } from "react";
import styles from "./UserSection.module.css";
import ChatBot, { Button, useFlow } from "react-chatbotify";
import { CHAT_MEMBER_ID, createChatFlow } from "../CreateFlow";
import { useAppDispatch, useAppSelector } from "../../../../store/common/hooks";
import { botInjector } from "../../../../store/chatbotInjector";
import {
  endConversationApiCall,
  onChatbotActions,
} from "../../../../store/chatbot.slice";
import useMediaQuery from "../../../../hooks/useMediaQuery";

export const CUSTOMER_SERVICE_CHAT = "customer_service_example";
interface UserSectionProps {}

export const AdminResponseListener = () => {
  const adminResponse = useAppSelector((state) => state.chatbot.adminResponse);

  useEffect(() => {
    if (adminResponse?.message && botInjector) {
      botInjector(`👩‍💼 Customer Service: ${adminResponse.message}`, "bot");
    } else if (adminResponse?.image_urls && botInjector) {
      if (adminResponse?.image_urls) {
        for (const url of adminResponse?.image_urls) {
          botInjector(
            <div style={{ padding: "8px", margin: "16px" }}>
              <img
                src={url}
                alt="context image"
                style={{ maxWidth: "200px", borderRadius: "8px" }}
              />
            </div>,
            "bot"
          );
        }
      }
    }
  }, [adminResponse]);

  return null;
};

const UserSection: React.FC<UserSectionProps> = ({}) => {
  const [thread, setThread] = useState<string>("1");
  const dispatch = useAppDispatch();
  const isLaptop: boolean = useMediaQuery("(min-width: 1600px)");

  const endConversation = useAppSelector(
    (state) => state.chatbot.isEndConversation
  );
  const { restartFlow } = useFlow();

  const changeThread = async () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 4; // or however long you want the thread ID
    let result = "";

    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    setThread(result);
    localStorage.removeItem(CUSTOMER_SERVICE_CHAT);
    await dispatch(endConversationApiCall(CHAT_MEMBER_ID));
  };

  useEffect(() => {
    let isMounted = true;
    const handleEndConversation = async () => {
      if (endConversation && isMounted) {
        try {
          dispatch(onChatbotActions.setEndConversation(false));
          // ensure restartFlow is safe

          restartFlow();

          changeThread();
        } catch (e) {
          console.error("restartFlow failed", e);
        }
      }
    };

    handleEndConversation();

    return () => {
      isMounted = false;
    };
  }, [endConversation]);

  useEffect(() => {
    changeThread();
  }, []);

  return (
    <div className={styles["container"]}>
      <ChatBot
        styles={{
          chatWindowStyle: isLaptop
            ? {
                display: "flex",
                flex: 1,
                width: "100%",
                maxWidth: "600px",
                height: "85dvh",
              }
            : {
                display: "flex",
                flex: 1,
                maxWidth: "600px",
                height: "85dvh",
              },
        }}
        settings={{
          general: { embedded: true },
          header: {
            title: "User Simulator",
            buttons: [Button.CLOSE_CHAT_BUTTON],
          },
          chatWindow: {
            showTypingIndicator: false,
          },
          chatInput: {
            allowNewline: true,
          },
          chatHistory: { storageKey: CUSTOMER_SERVICE_CHAT },
          event: {
            rcbPostInjectMessage: true,
          },
        }}
        flow={createChatFlow(thread)}
      />
      <AdminResponseListener />
    </div>
  );
};

export default UserSection;
